
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import RedirectionService from '@/services/redirectionService';

interface CanonicalLinkProps {
  customCanonical?: string;
  baseUrl?: string;
}

const CanonicalLink = ({ 
  customCanonical, 
  baseUrl = "https://www.groupefabre-environnement.fr" 
}: CanonicalLinkProps) => {
  const location = useLocation();
  const redirectionService = RedirectionService.getInstance();

  useEffect(() => {
    // Supprimer toute balise canonical existante
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Déterminer l'URL canonique
    let canonicalUrl: string;
    
    if (customCanonical) {
      canonicalUrl = customCanonical.startsWith('http') 
        ? customCanonical 
        : `${baseUrl}${customCanonical}`;
    } else {
      const canonicalPath = redirectionService.getCanonical(location.pathname);
      canonicalUrl = `${baseUrl}${canonicalPath}`;
    }

    // Créer et ajouter la nouvelle balise canonical
    const canonicalLink = document.createElement('link');
    canonicalLink.rel = 'canonical';
    canonicalLink.href = canonicalUrl;
    document.head.appendChild(canonicalLink);

    console.log(`Balise canonical ajoutée: ${canonicalUrl}`);

    // Cleanup
    return () => {
      const linkToRemove = document.querySelector(`link[rel="canonical"][href="${canonicalUrl}"]`);
      if (linkToRemove) {
        linkToRemove.remove();
      }
    };
  }, [location.pathname, customCanonical, baseUrl, redirectionService]);

  return null; // Ce composant ne rend rien visuellement
};

export default CanonicalLink;
